import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import { Typography2 } from '@coursera/cds-core';

import { InviteAcceptanceContainer } from 'bundles/enterprise-admin-onboarding/components/InviteAcceptance/ui';
import { Button, LargeText, PersonallyIdentifiableInfo, Spacer } from 'bundles/enterprise-ui/components';

import _t from 'i18n!nls/admin-dashboard';

const AlertIcon: React.FC<{}> = () => (
  <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.1204 50.2799H41.6254C43.7606 50.2796 45.8718 49.8298 47.8216 48.9597C49.7715 48.0897 51.5163 46.8188 52.9425 45.2298C54.3688 43.6409 55.4445 41.7694 56.0997 39.7372C56.7549 37.7051 56.9749 35.5577 56.7454 33.4349C56.2108 28.5247 53.7783 24.0179 49.9669 20.8764C46.1556 17.7348 41.2673 16.2073 36.3454 16.6199L32.6404 16.9199C27.0817 17.3863 21.9011 19.9242 18.1254 24.0305C14.3498 28.1367 12.2547 33.5117 12.2554 39.0899V41.4149C12.2534 42.5796 12.4814 43.7333 12.9262 44.8097C13.371 45.8862 14.0239 46.8642 14.8475 47.6878C15.6711 48.5114 16.6491 49.1643 17.7256 49.6091C18.802 50.0539 19.9557 50.2819 21.1204 50.2799Z"
      fill="var(--cds-color-yellow-300)"
    />
    <path
      d="M36.0001 10.8447L64.7551 61.1547H7.24512L36.0001 10.8447Z"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M36 28.8145V45.5845" stroke="black" strokeWidth="2" strokeLinejoin="round" />
    <path
      d="M36.0001 53.9699C37.3256 53.9699 38.4001 52.8954 38.4001 51.5699C38.4001 50.2444 37.3256 49.1699 36.0001 49.1699C34.6746 49.1699 33.6001 50.2444 33.6001 51.5699C33.6001 52.8954 34.6746 53.9699 36.0001 53.9699Z"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export class SwitchAccountForAdminAccess extends React.Component<
  {
    title?: string;
    description?: React.ReactNode;
    callToAction?: string;
    onLogout: () => void;
    onGoToCourseraHome: () => void;
    emailLoggedInWith: string;
  },
  {}
> {
  render() {
    const {
      title = _t('Switch account for admin access'),
      emailLoggedInWith,
      description = (
        <FormattedHTMLMessage
          message={_t(
            'You are currently logged into Coursera with <strong>{email}</strong> which does not have administrator privileges to access these features.'
          )}
          email={emailLoggedInWith}
        />
      ),
      callToAction = _t(
        'Please logout and login again using the email where you received the invitation to join as a program administrator.'
      ),
      onLogout,
      onGoToCourseraHome,
    } = this.props;
    return (
      <InviteAcceptanceContainer data-e2e="switch-account-for-admin-access">
        <Spacer size={64} />
        <AlertIcon />
        <Spacer size={48} />
        <Typography2 component="h1" variant="titleMedium">
          {title}
        </Typography2>
        <Spacer size={16} />
        <LargeText>
          <PersonallyIdentifiableInfo>{description}</PersonallyIdentifiableInfo>
        </LargeText>
        <Spacer size={16} />
        <LargeText>
          <FormattedHTMLMessage message={callToAction} />
        </LargeText>
        <Spacer size={48} />
        <Button variant="primary" onClick={onLogout} data-e2e="logout">
          {_t('Logout')}
        </Button>
        <Spacer size={24} />
        <Button variant="ghost" onClick={onGoToCourseraHome}>
          {_t('Go to Coursera Home')}
        </Button>
      </InviteAcceptanceContainer>
    );
  }
}
